import { Link, type InertiaLinkProps } from '@inertiajs/react'
import type { ButtonHTMLAttributes, ReactNode } from 'react'

type Variant = 'primary' | 'ghost'

const VARIANT: Record<Variant, string> = {
  primary: 'bg-flame text-paper border-2 border-ink shadow-hard',
  ghost: 'bg-card text-ink border-[1.5px] border-ink shadow-hard-sm',
}

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-bold transition-transform hover:-translate-y-0.5 motion-reduce:transform-none'

type Shared = { variant?: Variant; className?: string; children: ReactNode }
// `href` renders an Inertia <Link> and accepts link attributes; without it a
// real <button> accepts button attributes. The discriminated union forwards the
// right extra props to each branch instead of silently dropping them.
type LinkButton = Shared & { href: string } & Omit<InertiaLinkProps, 'href' | 'className' | 'children'>
type PlainButton = Shared & { href?: undefined } & Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className' | 'children'>

export function Button({ variant = 'primary', className = '', children, ...rest }: LinkButton | PlainButton) {
  const classes = `${BASE} ${VARIANT[variant]} ${className}`
  if (rest.href !== undefined) {
    return <Link className={classes} {...rest}>{children}</Link>
  }
  return <button className={classes} {...rest}>{children}</button>
}
